import { create } from 'zustand';
import { StatisticType } from '../types/dashboard.type';

/** Persists dashboard widget selection and month; operational stats share the flat ESG monthly JSON. */
interface DashboardState {
  selectedStats: StatisticType[];
  selectedMonth: string;
  setSelectedStats: (stats: StatisticType[]) => void;
  setSelectedMonth: (month: string) => void;
  saveDashboardPreferences: () => void;
  loadDashboardPreferences: () => void;
}

const useDashboardStore = create<DashboardState>((set, get) => ({
  selectedStats: [],
  selectedMonth: new Date().toISOString().slice(0, 7),

  setSelectedStats: (stats: StatisticType[]) => {
    set({ selectedStats: stats });
    get().saveDashboardPreferences();
  },

  setSelectedMonth: (month: string) => {
    set({ selectedMonth: month });
    get().saveDashboardPreferences();
  },

  saveDashboardPreferences: () => {
    const { selectedStats, selectedMonth } = get();
    sessionStorage.setItem(
      'dashboardPreferences',
      JSON.stringify({
        selectedStats,
        selectedMonth,
      })
    );
  },

  loadDashboardPreferences: () => {
    const storedPrefs = sessionStorage.getItem('dashboardPreferences');
    if (storedPrefs) {
      try {
        const { selectedStats, selectedMonth } = JSON.parse(storedPrefs);
        set({
          selectedStats: selectedStats || [],
          selectedMonth: selectedMonth || new Date().toISOString().slice(0, 7),
        });
      } catch {
        /* ignore */
      }
    }
  },
}));

export { useDashboardStore };
